export default "__VITE_ASSET__DCC72_78__"